import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MyDataForm_UpdateAuthenticatedUserAccount_Mutation = graphql(`
  mutation MyDataForm_UpdateAuthenticatedUserAccount(
    $currentPassword: NonEmptyString!
    $email: EmailAddress
    $newPassword: NonEmptyString
  ) {
    updateAuthenticatedUserAccount(
      currentPassword: $currentPassword
      email: $email
      newPassword: $newPassword
    ) {
      _id
      email
    }
  }
`);

export const useUpdateMyDataMutation = () =>
  useGraphQLMutation(MyDataForm_UpdateAuthenticatedUserAccount_Mutation);
